import * as React from "react";
import { Button } from "@draftkings/arena-web";
export const CashOutViewSuspended = React.memo(function CashOutViewSuspended(props) {
    const { formattedCashOutAmount, purchaseId } = props;
    return React.createElement(Button, { type: "button", disabled: true, variant: "cashOutButton:Suspended", widthMode: "stretch", testId: `cashout-button-${purchaseId}` }, formattedCashOutAmount);
});
//# sourceMappingURL=CashOutViewSuspended.js.map